import { render, staticRenderFns } from "./stayAverage.vue?vue&type=template&id=32977c66"
import script from "./stayAverage.vue?vue&type=script&lang=js"
export * from "./stayAverage.vue?vue&type=script&lang=js"
import style0 from "./stayAverage.vue?vue&type=style&index=0&id=32977c66&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports